var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.059-409.37q-29.016 0-49.853-20.777-20.836-20.778-20.836-49.794t20.777-49.853q20.778-20.836 49.794-20.836t49.853 20.777q20.836 20.778 20.836 49.794t-20.777 49.853q-20.778 20.836-49.794 20.836ZM280-234.5q-102.073 0-173.786-71.73Q34.5-377.96 34.5-480.056q0-102.096 71.714-173.77Q177.927-725.5 280-725.5q73.913 0 129.348 34.956 55.435 34.957 86.455 104.914h355.023L966.696-470 795.87-313.174l-88.24-64.478-87.76 63.761-75.957-60.479h-48.13q-25 60.718-79.895 100.294Q360.993-234.5 280-234.5Zm0-65.5q58.717 0 107.837-39.098 49.12-39.098 62.641-100.532h117.109l53.043 44.282 88-63 82 61.522 82.131-74.457-48.848-49.087H450.478q-11.282-56.956-59.664-98.293Q342.432-660 280-660q-75 0-127.5 52.5T100-480q0 75 52.5 127.5T280-300Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.f68d5be89a9443d79b26a49f9004d20a.svg";
export { ForwardRef as ReactComponent };